import React from "react";
import styles from "./CardField.module.css"
import {useAppDispatch} from "../../../../../../../app/hooks";
import {
    showCopiedSuccessfullyToastNotification
} from "../../../../../../elements/toastNotification/toastNotificationSlice";

export enum SignPosition {
    START,
    END
}

interface CardFieldProps {
    title: string;
    value?: string | number;
    sign?: string | number;
    signPosition?: SignPosition
    valueComponent?: React.FC<any>;
    props?: Record<string, any>;
}

export const CardField: React.FC<CardFieldProps> = ({
                                                        title,
                                                        value,
                                                        sign = "",
                                                        signPosition = SignPosition.END,
                                                        valueComponent: ValueComponent,
                                                        props,
                                                    }) => {

    const dispatch = useAppDispatch()
    const prepareValue = (): string => {
        if (value) {
            if (signPosition === SignPosition.END) {
                return `${value}${sign}`
            } else {
                const valueStr = value.toString();
                const isNegative = valueStr.startsWith("-");
                if (isNegative) {
                    const absValue = isNegative ? valueStr.slice(1) : valueStr;
                    return `-${sign}${absValue}`
                } else {
                    return `${sign}${value}`
                }
            }
        } else {
            return ""
        }
    }

    const fieldValue = prepareValue()
    const handleClickOnValue = () => {
        if (fieldValue) {
            dispatch(showCopiedSuccessfullyToastNotification({fieldName: "Value"}))
            navigator.clipboard.writeText(fieldValue);
        }
    }

    return (
        <div className={styles.wrapper}>
            <span className={styles.title}>{title}</span>
            {ValueComponent && props ? (
                <ValueComponent {...props} />
            ) : (
                <span className={styles.value} onClick={handleClickOnValue}>{fieldValue}</span>
            )}
        </div>
    );
};
